import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar';
import Footer from './pages/components/Footer';
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import NewsLetterListPage from './pages/NewsLetterListPage';
import NewsLetterPage from './pages/NewsLetterPage';
import NotFoundPage from './pages/NotFoundPage';
import SacramentsPage from './pages/SacramentsPage';
import BaptismPage from './pages/BaptismPage';
import FirstHolyCommunionPage from './pages/FirstHolyCommunionPage';
import HolyCommunionAtHomePage from './pages/HolyCommunionAtHomePage';
import ParishGroupsPage from './pages/ParishGroupsPage';
import BereavementGroupPage from './pages/BereavementGroupPage';
import BrowniesPage from './pages/BrowniesPage';
import GalleryPage from './pages/GalleryPage';
import ContactUsPage from './pages/ContactUsPage';
import MotherOfMercyPage from './pages/MotherOfMercyPage';
import NewsAndEventsPage from './pages/NewsAndEventsPage';
import EventPosterPopup from './pages/components/EventPosterPopup';

function App() {
  return (
    <BrowserRouter>
    <div className="App">
      <NavBar />
      <EventPosterPopup />
      <div id="page-body">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/news-letters" element={<NewsLetterListPage />} />
          <Route path="/news-letters/:newsletterId" element={<NewsLetterPage />} />
          <Route path="/news-and-events" element={<NewsAndEventsPage />} />
          <Route path="/sacraments" element={<SacramentsPage />} />
          <Route path="/parish-groups" element={<ParishGroupsPage />} />
          <Route path="/bereavement-group" element={<BereavementGroupPage />} />
          <Route path="/brownies" element={<BrowniesPage />} />
          <Route path="/mother-of-mercy-group" element={<MotherOfMercyPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/baptism" element={<BaptismPage />} />
          <Route path="/first-holy-communion" element={<FirstHolyCommunionPage />} />
          <Route path="/holy-communion-at-home" element={<HolyCommunionAtHomePage />} />
          <Route path="/*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer/>
    </div>
    </BrowserRouter>
  );
}

export default App;
